import "@/utils/safeStorage";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import AppErrorBoundary from "@/components/AppErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
);

// 2026-05-24 Deploy-Safe Auth: Signalisiert dem index.html-Bootloader
// dass die App erfolgreich geladen wurde. Verhindert "ghost reset" bei
// hängenden Service-Workern (siehe public/index.html → __gle_appReady).
if (typeof window !== 'undefined' && typeof window.__gle_appReady === 'function') {
  // Mikro-Timeout damit React-Mount tatsächlich abgeschlossen ist
  setTimeout(() => { try { window.__gle_appReady(); } catch (_) {} }, 0);
}
